// assets/custom-scent-descriptions.js

document.addEventListener('DOMContentLoaded', () => {
  console.log('[afterglohe] scent script loaded');

  // 1. Read the metafield data that Liquid rendered in variant-main-picker.liquid
  let scentDescriptions = {};

  const scentScript = document.querySelector('script[data-variant-scent-metafields]');
  if (scentScript) {
    try {
      const text = scentScript.textContent.trim();
      scentDescriptions = text ? JSON.parse(text) : {};
      console.log('[afterglohe] scent map:', scentDescriptions);
    } catch (e) {
      console.warn('[afterglohe] Could not parse variant scent metafields JSON', e);
    }
  } else {
    console.warn('[afterglohe] No data-variant-scent-metafields script found');
  }

  function updateScentDescriptionByVariantId(variantId) {
    const container = document.querySelector('[data-scent-description]');
    if (!container) {
      console.warn('[afterglohe] No [data-scent-description] container found');
      return;
    }

    const key = String(variantId);
    const description = scentDescriptions[key] || '';

    console.log('[afterglohe] update scent for variant', key, '→', description);

    // description is HTML from metafield_tag, so we use innerHTML
    container.innerHTML = description;
  }

  // 2. Listen for Horizon's variant:update event
  document.addEventListener('variant:update', (event) => {
    console.log('[afterglohe] variant:update event', event.detail);
    const variant = event.detail && event.detail.resource;
    if (!variant || !variant.id) {
      console.warn('[afterglohe] variant:update without variant/id');
      return;
    }

    updateScentDescriptionByVariantId(variant.id);
  });

  // 3. On initial load, read the JSON for selected_or_first_available_variant
  function getInitialVariantFromPicker() {
    // Prefer the main product's picker
    let picker = document.querySelector(
      'variant-picker[data-template-product-match="true"]'
    );
    if (!picker) {
      picker = document.querySelector('variant-picker');
    }
    if (!picker) {
      console.warn('[afterglohe] No <variant-picker> found');
      return null;
    }

    // First JSON script inside this picker is the selected_or_first_available_variant
    const scriptEl = picker.querySelector(
      'script[type="application/json"]:not([data-variant-scent-metafields])'
    );
    if (!scriptEl) {
      console.warn('[afterglohe] No initial variant JSON script found in picker');
      return null;
    }

    try {
      const variant = JSON.parse(scriptEl.textContent.trim());
      console.log('[afterglohe] initial variant from picker', variant);
      return variant;
    } catch (e) {
      console.warn('[afterglohe] Unable to parse initial variant JSON', e);
      return null;
    }
  }

  const initialVariant = getInitialVariantFromPicker();
  if (initialVariant && initialVariant.id) {
    updateScentDescriptionByVariantId(initialVariant.id);
  } else {
    console.warn('[afterglohe] Could not detect initial variant ID');
  }
});
